import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { getRemoteText, getRemoteValue } from "../../Utils/firebase";
import { sendEvent } from "../../Utils/firebaseLogger";
import { FooterProps } from "./Footer";
import StoreButtons from "./StoreButtons";

const CustomAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: "#101115",
  color: "white",
  boxShadow: "none",
  position: "relative",
  "&::before": {
    top: "65px",
    backgroundColor: "#2A2D33",
  },
}));

export default function MobileFooter({ handleWhatsAppClick, handleMailClick, handleCallCenterClick }: FooterProps) {
  return (
    <Box
      sx={{
        backgroundColor: "#101115",
        color: "white",
      }}
    >
      <Box
        sx={{
          padding: "32px 16px",
          "@media (min-width: 768.5px)": {
            padding: "20px 8%",
          },
        }}
      >
        {/* Logo ve Açıklama — CRL-3241: kodi+ brand lockup */}
        <Link to="/">
          <Stack direction={"row"} alignItems={"center"} gap={"12px"}>
            <img
              src={"/kodi-icon.svg"}
              alt="kodi+"
              style={{ width: "46px", height: "46px", borderRadius: "11px" }}
            />
            <Stack lineHeight={1.2}>
              <Typography fontSize={"15px"} fontWeight={700} color={"#FFF"}>
                {getRemoteText("brand_name", "kodi+")}
              </Typography>
              <Typography fontSize={"12px"} color={"rgba(255,255,255,.55)"}>
                {getRemoteText("brand_by", "by Colendi")}
              </Typography>
            </Stack>
          </Stack>
        </Link>
        <Typography
          variant="body2"
          sx={{ margin: "20px 0" }}
          fontSize={"14px"}
          fontWeight={400}
        >
          {getRemoteValue("footer_text")}
        </Typography>

        {/* Sosyal Medya İkonları */}
        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "15px",
            marginBottom: "20px",
          }}
        >
          <IconButton color="inherit" href={getRemoteValue("facebook_link")}>
            <img src={"/icons/facebook.svg"} alt="colendi_facebook" />
          </IconButton>
          <IconButton color="inherit" href={getRemoteValue("linkedin_link")}>
            <img src={"/icons/linkedin.svg"} alt="colendi_linkedin" />
          </IconButton>
          <IconButton color="inherit" href={getRemoteValue("twitter_link")}>
            <img src={"/icons/x.svg"} alt="colendi_x" />
          </IconButton>
          <IconButton color="inherit" href={getRemoteValue("instagram_link")}>
            <img src={"/icons/instagram.svg"} alt="colendi_instagram" />
          </IconButton>
        </Box> */}

        {/* Genel ve İletişim Accordion Menüler */}
        <CustomAccordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
            sx={{ paddingY: 2, paddingX: 0 }}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography sx={{ flexShrink: 0, fontWeight: "bold" }}>
              {getRemoteValue("general")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "0px 8px 8px" }}>
            <Stack gap={3}>
              <Link to="/" color="inherit" style={{ fontSize: "14px" }}>
                <ArrowRightIcon fontSize="small" />
                {getRemoteValue("debts")}
              </Link>
              <Link
                to="/sss"
                color="inherit"
                style={{ fontSize: "14px" }}
                onClick={() => {
                  sendEvent(`click_faq`, {});
                }}
              >
                <ArrowRightIcon fontSize="small" />
                {getRemoteValue("faq")}
              </Link>
            </Stack>
          </AccordionDetails>
        </CustomAccordion>
        <CustomAccordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
            aria-controls="panel2bh-content"
            sx={{ paddingY: 2, paddingX: 0 }}
            id="panel2bh-header"
          >
            <Typography sx={{ flexShrink: 0, fontWeight: "bold" }}>
              {getRemoteValue("communication")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "0px 8px 8px" }}>
            <Stack gap={3}>

              <Stack
                onClick={handleCallCenterClick}
                display={"flex"}
                direction={"row"}
                alignItems={"center"}
              >
                <Stack mr={1}>
                  <img
                    width={"16px"}
                    src={"/icons/phone-icon-white.svg"}
                    alt=""
                  />
                </Stack>
                <Typography variant="body2" fontSize={"14px"}>
                  {getRemoteValue("colendi_info_callcenter_label")}
                </Typography>
              </Stack>

              <Stack
                onClick={handleWhatsAppClick}
                display={"flex"}
                direction={"row"}
                alignItems={"center"}
              >
                <Stack mr={1}>
                  <img
                    className="contact-icon"
                    src={"/icons/whatsapp-icon-white.svg"}
                    alt=""
                  />
                </Stack>
                <Typography variant="body2" fontSize={"14px"}>
                  {getRemoteValue("colendi_info_whatsapp_label")}
                </Typography>
              </Stack>

              <Stack
                onClick={handleMailClick}
                display={"flex"}
                direction={"row"}
                alignItems={"center"}
              >
                <Stack mr={1}>
                  <img
                    width={"16px"}
                    src={"/icons/mail-icon-white.svg"}
                    alt=""
                  />
                </Stack>
                <Typography variant="body2" fontSize={"14px"}>
                  {getRemoteValue("colendi_info_mail")}
                </Typography>
              </Stack>

              <Stack display={"flex"} direction={"row"} alignItems={"center"}>
                <img
                  src={"/icons/location-icon-white.svg"}
                  alt=""
                  style={{ marginRight: "8px" }}
                />
                <Typography
                  variant="body2"
                  fontSize={"14px"}
                  maxWidth={"200px"}
                >
                  {getRemoteValue("colendi_adress")}
                </Typography>
              </Stack>
            </Stack>
          </AccordionDetails>
        </CustomAccordion>
        <Box width={"100%"} display={"flex"} alignItems={"center"} justifyContent={"center"} mt={3}>
          <StoreButtons />
        </Box>
        {/* Alt Bilgi */}
      </Box>
      {/* CRL-3241: simple bordered copyright strip (design footer__legal) */}
      <Box
        sx={{
          borderTop: "1px solid rgba(255,255,255,.08)",
          py: "17px",
          textAlign: "center",
        }}
      >
        <Typography fontSize={"13px"} color={"rgba(255,255,255,.45)"}>
          {getRemoteText("footer_by_colendi", "2026 © kodi+ · by Colendi")}
        </Typography>
      </Box>
    </Box>
  );
}
